import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TrainFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 3C1 2.44772 1.44772 2 2 2H9.33333C11.2807 2 13.1755 2.6316 14.7333 3.8L20.6 8.2C22.1108 9.33313 23 11.1115 23 13C23 14.6569 21.6569 16 20 16H2C1.44772 16 1 15.5523 1 15V12.75H8.00119C8.4154 12.75 8.75119 12.4142 8.75119 12C8.75119 9.37665 6.62454 7.25 4.00119 7.25H1V3ZM1 8.75V11.25H7.16422C6.82564 9.81665 5.53798 8.75 4.00119 8.75H1ZM19.4 9.8C19.5822 9.93663 19.7508 10.0873 19.9048 10.25H17C14.6528 10.25 12.75 8.34721 12.75 6V4.89046C13.021 5.04202 13.2828 5.21208 13.5333 5.4L19.4 9.8Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 19C1 18.4477 1.44772 18 2 18H22C22.5523 18 23 18.4477 23 19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 18C6.55228 18 7 18.4477 7 19V21C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21V19C5 18.4477 5.44772 18 6 18ZM12 18C12.5523 18 13 18.4477 13 19V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V19C11 18.4477 11.4477 18 12 18ZM18 18C18.5523 18 19 18.4477 19 19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19C17 18.4477 17.4477 18 18 18Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TrainFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TrainFilledIcon;
